<template>
	<div>
		<a-modal v-show='!ishand' id='warp_sim12' width='40rem' v-model="visible" on-ok="handleOk1"
		v-dragModal
		:dialog-style="{ top: (28 - (itemobj.amount*3.5>7?7:itemobj.amount*3.5))+'vh' }"
			@cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
			<div class='mark-file'>
				<div
					style="background-color: #0c8b97;border-radius:  10px 10px 0 0;color: #fff;width: 38rem;margin: 1rem 1rem 0 1rem;text-align: center;">
					回訪狀態
				</div>
			</div>
			<div solt='title' style="position: relative;">
				<!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
			</div>
			<div style="paddingBottom: 1rem;border-radius: 0 0 10px 10px;padding: 1rem;background-color: #fff;
			width: 38rem;margin: 0 auto;marginBottom: 1rem;">
				<div style="padding-top: 1.5rem;position: relative;left: -.5rem;">
					<a-form-model ref='form' :model="form" labelAlign='right' layout="inline" :rules='rules'
						hideRequiredMark>
						<a-row>
							<a-col :span='12'>
								<a-form-model-item label='邀請編號' prop='inviter'>
									<div style="text-align: left;font-size: .8rem;">
										{{form.inviter}}
									</div>
								</a-form-model-item>
							</a-col>
							<a-col :span='12'>
							<!-- 	<a-form-model-item label='提交時間' prop='step_datetime'>
									<div style="text-align: left;font-size: .8rem;">
										{{form.step_datetime}}
									</div>
								</a-form-model-item> -->
								<a-form-model-item prop='cal'>
									<div slot='label' v-html='"稱&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;呼"'
										style="display: inline-block;color: #000000;"></div>
									<div style='width:75%'> 
											<div v-if='form.cancelflag == 1||itemobj.kfstatus == "已提交"' style='textAlign:left'>
												{{form.cal==0?'先生':form.cal==1?'女士':''}}
											</div>
											<a-radio-group v-model="form.cal" v-else >
												<a-radio value="0">先生</a-radio>
												<a-radio value="1">女士</a-radio>
											</a-radio-group>
									</div>
								</a-form-model-item>
							</a-col>
						</a-row>
						<a-row>
							<a-col :span='12'>
								<a-form-model-item prop='cn_name' label='中文姓名'>
									<div v-if='form.cancelflag == 1||itemobj.kfstatus == "已提交"' class='myleft'>{{form.cn_name}}</div>
									<a-input v-model="form.cn_name" v-else
										onkeyup="value=value.replace(/[^\u4e00-\u9fa5]/g,'')"/>
								</a-form-model-item>
							</a-col>
							<a-col :span='12'>
								<a-form-model-item prop='en_name' label='英文姓名'>
									<div v-if='form.cancelflag == 1||itemobj.kfstatus == "已提交"' class='myleft'>{{form.en_name}}</div>
									<a-input v-model="form.en_name" v-else
										onkeyup="value=value.replace(/[^a-z A-Z]/g,'')" />
								</a-form-model-item>
							</a-col>
						</a-row>
						<!-- <a-row>
							<a-col :span='12'>
							</a-col>
							<a-col :span='12'>
								<a-form-model-item label='回訪時間' prop='revisit_duration'>
									<a-input v-model="form.revisit_duration" placeholder=' ' />
								</a-form-model-item>
							</a-col>
						</a-row> -->
						<div id='lastname'  v-if='form.cancelflag !== 1&&itemobj.kfstatus !== "已提交"'>
							<a-form-model-item prop='revisit_remark'>
								<div slot='label' v-html='"回訪內容"' style="display: inline-block;color: #000000;"></div>
								<a-textarea v-model="form.revisit_remark" placeholder=" "
									:auto-size="{ minRows: 3, maxRows: 5 }" style='width: 30.5rem;' :maxLength='22'/>
							</a-form-model-item>
						</div>
					</a-form-model>
					<a-row v-if='form.revisitLogList.length'>
						<div class='mydivs'>
							<div v-for='(item,ind) in form.revisitLogList'>
								<div class='f'>
									<div class='c'> 
									<img style="width: .9rem;margin-top: -.2rem;" :src="require('@/image/dianhua.png')" alt=""> 
								{{item.revisit_remark}}</div>
									<!-- <div class='c'>回訪時間:{{item.revisit_duration}}</div> -->
									<div class='c' style='font-size: .7rem;'>
									{{item.revisit_datetime}}
									</div>
								</div>
								<div class='t' v-if='ind !== form.revisitLogList.length-1'></div>
							</div>
						</div>
					</a-row>
					<div style="text-align: center;" v-if='form.cancelflag !== 1&&itemobj.kfstatus !== "已提交"'>
						<button class='btn1 btnx' @click='handbect("form")' v-html='"保&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;存"'></button>
						<button class='btn1 btn2' @click='resetForm("form")'>取消開戶</button>
					</div>
				</div>
			</div>
			<div style="width: 100%;height: 1px;"></div>
		</a-modal>
	</div>
</template>

<script>
	import App from '@/assets/app.js';
	export default {
		props: ['itemobj'],
		data() {
			return {
				loading:true,
				ishand: false,
				visible: true,
				rules: {
					// revisit_duration: [{
					// 	required: true,
					// 	message: ' ',
					// 	trigger: 'blur'
					// }],
					register_date: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					revisit_remark: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
				},
				form: {
					cal: "",
					cn_name: "",
					en_name: "",
					inviter: '',
					khcreatedate: "", //创建时间
					nationcode: "",
					phonenum: "",
					revisit_duration: '',
					revisit_remark: '',
					revisitLogList: [],
					step_datetime: ''
				},
			}
		},
		mounted() {
			this.handz()
			console.log(this.itemobj.kfstatus)
			// window.addEventListener('')
		},
		methods: {
			handz(val) {
				this.$ajax({
					method: 'post',
					url: this.$api.getRevis,
					data: {
						"nationcode": this.itemobj.nationcode,
						"phonenum": this.itemobj.phonenum,
						'khcreatedate': this.itemobj.khcreatedate,
					}
				}).then(res => {
					if (res.data) {
						this.form = res.data
						// App.oTool.successT();
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			resetForm(ruleForm) {
				// if(this.loading){
					// this.loading = false
				// this.$refs[ruleForm].resetFields();
				this.$refs[ruleForm].validate(valid => {
					if (valid) {
						this.form.token = this.$store.state.token;
						this.form.cancelflag = 1
						this.$ajax({
							method: 'post',
							url: this.$api.setedit,
							data: this.form
						}).then(res => {
							if (res.data.qmiscode === 1000) {
								App.oTool.successT();
								this.$emit('child', 1)
							} else {
								App.oTool.warningT(res.data.qmismsg);
							}
						})
						} else {
								console.log('error submit!!');
								return false;
							}
						});
				// }
			},
			//下单
			handbect(ruleForm) {
				this.$refs[ruleForm].validate(valid => {
					if (valid) {
						// this.form.expire_date = this.form.expire_date._d ? App.oDate.secsTime3(this.form.expire_date._d) : this.form.expire_date;
						this.form.token = this.$store.state.token;
						this.form.flag = "domainname";
						this.$ajax({
							method: 'post',
							url: this.$api.setedit,
							data: this.form
						}).then(res => {
							if (res.data.qmiscode === 1000) {
								App.oTool.successT();
								this.$emit('child', 1)
							} else {
								App.oTool.warningT(res.data.qmismsg);
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			handleOk1() {

			}
		}
	}
</script>

<style lang="scss">
	#warp_sim12 .ant-modal-header,
	#warp_sim12 .ant-modal-body {
		background-color: #e5e5e5 !important;
		padding: 1rem;
		padding-top: 0.7rem;
	}

	.mark-file {
		position: absolute;
		top: 0;
		left: 0;

		div {
			width: 6rem;
			font-size: 1rem;
			padding: .5rem 1rem;
			display: inline-block;
		}
	}

	#warp_sim12 {
		.ant-radio-wrapper{
			display: flex;
			align-items: center;
		}
		.ant-form-explain {
			display: none;
		}

		.ant-modal {
			// top: 15vh;
		}

		.ant-col-12 {
			text-align: right;
		}
		.myleft{
			text-align: left;
		}
		.ant-form-item-label {
			width: 30%;
		}

		.ant-form-item,
		.ant-form-item-control {
			width: 100%;

			.ant-calendar-picker {
				width: 100%;
			}

		}

		.ant-radio-group-default {
			width: 100%;
			margin-top: .3rem;
			display: flex;
			justify-content: space-between;
			align-items: center;

			span {
				font-size: .8rem;
			}
		}

		.ant-form-item-control-wrapper {
			width: 70%;

			.ant-form-item-control {
				width: 100%;
			}
		}

		#lastname {
			text-align: right;

			.ant-form-item-label {
				width: 10%;
			}

			.ant-form-item-control-wrapper {
				width: 86%;
			}
		}

		.ant-form-inline .ant-form-item {
			margin-right: 0;
		}

		

		.ant-modal-content {
			border-radius: 10px;
		}

		.ant-form-item {
			margin-bottom: 1rem;
		}

		.ant-form-item label {
			font-size: .8rem !important;
		}

		.ant-input {
			font-size: .8rem !important;
		}

		.ant-select-selection-selected-value {
			font-size: .8rem !important;
		}

		.ant-form-item-children {
			font-size: .8rem !important;
		}

		.ant-modal-body {
			padding: 0;
			padding-top: 2.5rem;
		}

		.btn1 {
			cursor: pointer;
			width: 8rem;
			height: 2rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			margin: 0 3rem;
		}

		.btnx {
			background-color: #0c8b97;
		}

		.btn2 {
			background-color: #ed4849;
		}

		.mydivs {
			max-height: 7rem;
			overflow-y: auto;
			// margin-bottom: 1rem;
			padding: 1rem;
			margin-left: 4%;
			width: 96%;
			background-color: #f5f5f5;
			margin-bottom: 1rem;
			
			.c {
				font-size: .8rem;
			}

			.f {
				// text-align: right;
				display: flex;
				justify-content: space-between;
			}

			.t {
				margin: .5rem 0;
				border-bottom: 1px solid #d9d9d9;
			}
		}
	}
	// @media screen and(min-width: 1921px){
	// 	#warp_sim12 {
	// 		.ant-modal-close-x {
	// 			.anticon svg {
	// 				top: 1.5rem !important;
	// 			}
	// 		}
	// 	}
	// }.ant-modal-close-x {
	// 		.anticon svg {
	// 			color: #5cb1b9;
	// 			position: relative;
	// 			top: .7rem;
	// 			right: 1rem;
	// 		}
	// 	}
</style>
